import { Grid } from '@mui/material';
import { HSpacer, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import IconNorthStar from '../../../../assets/img/shared/icon-northStar.svg';
import { RoutalIcon } from '../../../../assets/svg/RoutalIcon';
import Button from '../../../../react-components/Button';
import { Text } from '../../../../react-components/Text';
import { useUpgradeDialogVisibility } from '../../hooks/useUpgradeDialogVisibility';

export const SubscriptionPill = () => {
  const { setDialogVisibility } = useUpgradeDialogVisibility();
  return (
    <Grid
      style={{
        padding: `24px 20px`,
        position: `relative`,
        backgroundColor: RoutalPalette.primary40n,
        borderRadius: `10px`,
      }}
    >
      <Grid
        style={{
          position: `absolute`,
          top: 0,
          left: 0,
          height: `22px`,
          width: `22px`,
          borderRadius: `10px 0px`,
          backgroundColor: RoutalPalette.primary00,
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
        }}
      >
        <RoutalIcon style={{ marginRight: `2px`, marginBottom: `1px` }} />
      </Grid>
      <Text
        variant="body"
        style={{ color: RoutalPalette.secondary00 }}
        intlId="drivers.preferences.subscribe.title"
        intlValues={{
          color: (chunks: any) => <span style={{ color: RoutalPalette.primary20, fontWeight: 500 }}>{chunks}</span>,
        }}
      />

      <VSpacer small />
      <Button style={{ height: `25px`, margin: `0px` }} onClick={() => setDialogVisibility(true)}>
        <Text variant="body" style={{ color: RoutalPalette.white }} intlId="drivers.preferences.subscribe.button" />
        <HSpacer small />
        <img src={IconNorthStar} alt="NorthStar" style={{ height: `15px`, width: `15px` }} />
      </Button>
    </Grid>
  );
};
